import Page from '../base/Page';

export default class HomePage extends Page
{
    constructor() {
        super('.home-page');
    }

    init() {
        console.log('loaded home page');
    }
}


// WEBPACK FOOTER //
// ./javascript/pages/HomePage.js